import { MuscleGroup } from '../../types';

export const mockMuscleGroups: MuscleGroup[] = [
  // Upper Body
  { id: 'chest', name: 'Chest', split: false, category: 'Upper Body' },
  { id: 'back-upper', name: 'Upper Back', split: true, category: 'Upper Body', subCategory: 'Back' },
  { id: 'back-lower', name: 'Lower Back', split: false, category: 'Upper Body', subCategory: 'Back' },
  { id: 'shoulders-anterior', name: 'Anterior Deltoids', split: true, category: 'Upper Body', subCategory: 'Shoulders' },
  { id: 'shoulders-medial', name: 'Medial Deltoids', split: true, category: 'Upper Body', subCategory: 'Shoulders' },
  { id: 'shoulders-posterior', name: 'Posterior Deltoids', split: true, category: 'Upper Body', subCategory: 'Shoulders' },
  { id: 'biceps', name: 'Biceps', split: true, category: 'Upper Body', subCategory: 'Arms' },
  { id: 'triceps', name: 'Triceps', split: true, category: 'Upper Body', subCategory: 'Arms' },
  { id: 'forearms', name: 'Forearms', split: true, category: 'Upper Body', subCategory: 'Arms' },
  { id: 'traps', name: 'Trapezius', split: false, category: 'Upper Body' },
  
  // Lower Body
  { id: 'quadriceps', name: 'Quadriceps', split: true, category: 'Lower Body', subCategory: 'Thighs' },
  { id: 'hamstrings', name: 'Hamstrings', split: true, category: 'Lower Body', subCategory: 'Thighs' },
  { id: 'glutes', name: 'Glutes', split: true, category: 'Lower Body' },
  { id: 'calves', name: 'Calves', split: true, category: 'Lower Body' },
  { id: 'tibialis', name: 'Tibialis Anterior', split: true, category: 'Lower Body' },
  
  // Core
  { id: 'abs-upper', name: 'Upper Abs', split: false, category: 'Core', subCategory: 'Abdominals' },
  { id: 'abs-lower', name: 'Lower Abs', split: false, category: 'Core', subCategory: 'Abdominals' },
  { id: 'obliques', name: 'Obliques', split: true, category: 'Core', subCategory: 'Abdominals' },
  { id: 'deep-core', name: 'Deep Core', split: false, category: 'Core' },
];

export const mockMuscleGroupStats = {
  total: mockMuscleGroups.length,
  splitMuscles: mockMuscleGroups.filter(mg => mg.split).length,
  categories: new Set(mockMuscleGroups.map(mg => mg.category)).size,
  coverage: 85,
};

export const mockCategoryDistribution = [
  {
    title: 'Upper Body',
    percent: (mockMuscleGroups.filter(mg => mg.category === 'Upper Body').length / mockMuscleGroups.length) * 100,
    status: 'success' as const,
  },
  {
    title: 'Lower Body', 
    percent: (mockMuscleGroups.filter(mg => mg.category === 'Lower Body').length / mockMuscleGroups.length) * 100,
    status: 'normal' as const,
  },
  {
    title: 'Core',
    percent: (mockMuscleGroups.filter(mg => mg.category === 'Core').length / mockMuscleGroups.length) * 100,
    status: 'normal' as const,
  },
  {
    title: 'Functional',
    percent: (mockMuscleGroups.filter(mg => mg.category === 'Functional').length / mockMuscleGroups.length) * 100,
    status: 'exception' as const,
  },
]; 